<template>
    <header>
        <div class="container">
            <div class="d-flex flex-nowrap">
                <a href="/" class="vodafone-logo">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g><g><path fill="#e60000" d="M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24"/></g><g><path fill="#fff" d="M24.27 37c-6.49.022-13.24-5.564-13.27-14.532-.02-5.932 3.153-11.64 7.209-15.028 3.956-3.303 9.375-5.423 14.29-5.44.632-.002 1.294.051 1.7.19-4.298.898-7.719 4.932-7.703 9.508 0 .151.014.313.028.388C33.715 13.853 36.98 18.23 37 24.284c.02 6.055-4.72 12.69-12.73 12.716"/></g></g></svg>
                </a>
                <nav role="navigation">
                    <ul class="primary-nav"
                        :class="{ mobile_toggle: showMenu }"    
                    >
                        <li v-for="(item, index) in items" :key="index" 
                            @mouseenter="enter(item)"
                            @mouseleave="leave(item)"    
                        >
                            <a  
                                @click.self.prevent="toggleSubmenu($event, item)"
                                :class="{ active: item.active }"
                                :href="item.url"
                                class="main-links"
                            >
                                {{ item.name }}

                            </a>
                            <div v-if="item.active" 
                                class="level level--primary w-100"
                            >
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12">
                                            <ul class="sub-nav">
                                                <li v-for="(item, index) in item.children" :key="index"
                                                    @mouseenter="enter(item)"
                                                    @mouseleave="leave(item)"
                                                    :class="{ 'position-unset': item.megaMenu }"
                                                >
                                                    <a  
                                                        @click.self.prevent="toggleSubmenu($event, item)"
                                                        :class="{ active: item.active }"
                                                        :href="item.url"
                                                    >
                                                        {{ item.name }}

                                                    </a>
                                                    <div class="level level--primary" 
                                                        v-if="item.active"
                                                        :class="{ 'level--mega-menu': item.megaMenu }"
                                                    >
                                                        <div :class="{ container: item.megaMenu, 'position-relative': item.megaMenu }">
                                                            <div :class="{ row: item.megaMenu }">
                                                                <ul class="max300">
                                                                    <li class="w-100 mega-menu-item" v-for="(item, index) in item.children" :key="index"
                                                                        @mouseenter="enter(item)"
                                                                        @mouseleave="leave(item)"
                                                                        :class="{ 'position-unset': item.arrow}"
                                                                    >
                                                                        <a
                                                                            :class="{ 'active': item.active }"
                                                                            @click.self.prevent="toggleSubmenu($event, item)"
                                                                        >
                                                                            {{ item.name }}
                                                                            <div :class="{ 'arrow-r': item.arrow }"></div>
                                                                        </a>
                                                                        <div class="level level--primary" v-if="item.active"
                                                                            :class="{ 'level--mega-menu-right': item.arrow }"
                                                                        >
                                                                            <ul class="level--mega-menu-right-list">
                                                                                <li class="w-100 level--mega-menu-right-list-item" v-for="(item, index) in item.children" :key="index"
                                                                                    @mouseenter="enter(item)"
                                                                                    @mouseleave="leave(item)"
                                                                                >
                                                                                    <a
                                                                                        @click.self.prevent="toggleSubmenu($event, item)"
                                                                                        :class="{ 'active': item.active }"
                                                                                    >
                                                                                        {{ item.name }}

                                                                                    </a>
                                                                                    <div v-if="windowWidth < 1200">

                                                                                        <div class="level level--primary" v-if="item.active">
                                                                                            <ul>
                                                                                                <li class="w-100"
                                                                                                    v-for="(item, index) in item.children" :key="index"
                                                                                                    @mouseenter="enter(item)"
                                                                                                    @mouseleave="leave(item)"
                                                                                                >
                                                                                                    <a
                                                                                                        @click.self.prevent="toggleSubmenu($event, item)"
                                                                                                        :class="{ 'active': item.active }"
                                                                                                    >
                                                                                                        {{ item.name }}
                                                                                                    </a>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-else>
                                                                                        <div>
                                                                                            <ul>
                                                                                                <li class="w-100"
                                                                                                    v-for="(item, index) in item.children" :key="index"
                                                                                                    @mouseenter="enter(item)"
                                                                                                    @mouseleave="leave(item)"
                                                                                                >
                                                                                                    <a
                                                                                                        @click.self.prevent="toggleSubmenu($event, item)"
                                                                                                        :class="{ 'active': item.active }"
                                                                                                    >
                                                                                                        {{ item.name }}
                                                                                                    </a>
                                                                                                </li>
                                                                                            </ul>
                                                                                        </div>
                                                                                    </div>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div @click="showMenu = !showMenu;" class="mobile-burger">
                        <span class="mobile-burger--icon"
                            :class="{ 'mobile-burger--icon-show': showMenu }"
                        ></span>
                    </div>
                    <div class="myvodafone">
                        <ul>
                            <li v-for="(item, index) in myvodafone" :key="index"
                                @mouseenter="item.active = true"
                                @mouseleave="item.active = false"
                            >
                                <a 
                                    :class="{ active: item.active }"
                                    @click.self.prevent="toggleSubmenu($event, item)"
                                >
                                    <span class="user-icon"></span>

                                    <div class="level level--relative" v-if="item.active">
                                        <ul>
                                            <li class="w-100" v-for="(item, index) in item.children" :key="index">
                                                <a :href="item.url">
                                                    {{ item.name }}
                                                </a>
                                            </li>
                                        </ul>
    
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    </header>
</template>

<script>
    
    export default {
        name: "Header",
        data() {
            return {
                windowWidth: 0,
                showMenu: false,
                myvodafone: [
                    {
                        icon: 'user-icon',
                        active: false,
                        children: [
                            {
                                name: 'My Vodafone',
                                url: 'https://www.vodafone.ro/myvodafone/index.htm',
                                active: false
                            },
                            {
                                name: 'My Vodafone Fix & TV',
                                url: 'https://my.upc.ro',
                                active: false
                            }
                        ]
                    }
                ],
                items: [
                    {
                        name: 'Telefoane',
                        url: 'https://www.vodafone.ro/telefoane',
                        active: false,
                        children: [
                            {
                                name: 'Toate telefoanele',
                                url: 'https://www.vodafone.ro/telefoane',
                                active: false
                            },
                            {
                                name: 'Pachete speciale',
                                url: 'https://www.vodafone.ro/pachete?ic_source=website&ic_medium=link&ic_name=pachetemeniu',
                                active: false
                            },
                            {
                                name: 'Samsung',
                                url: 'https://www.vodafone.ro/telefoane/Samsung',
                                active: false
                            },
                            {
                                name: 'Apple iPhone',
                                url: 'https://www.vodafone.ro/telefoane/Apple',
                                active: false
                            },
                            {
                                name: 'Huawei',
                                url: 'https://www.vodafone.ro/telefoane/Huawei',
                                active: false
                            },
                            {
                                name: 'Vodafone',
                                url: 'https://www.vodafone.ro/telefoane/Vodafone',
                                active: false
                            },
                            {
                                name: 'LG',
                                url: 'https://www.vodafone.ro/telefoane/LG',
                                active: false
                            },
                            {
                                name: 'VoLTE',
                                url: 'https://www.vodafone.ro/volte',
                                active: false
                            },
                            {
                                name: 'eSim',
                                url: 'https://www.vodafone.ro/esim',
                                active: false
                            },
                        ]
                    },
                    {
                        name: 'Abonamente',
                        url: 'https://www.vodafone.ro/abonamente',
                        active: false,
                        children: [
                            {
                                name: 'Toate abonamentele',
                                url: 'https://www.vodafone.ro/abonamente',
                                active: false
                            },
                            {
                                name: 'Plată factură',
                                url: 'https://www.vodafone.ro/myvodafone/plata-factura-online/index.htm',
                                active: false
                            },
                            {
                                name: 'Internațional',
                                url: 'https://www.vodafone.ro/personal/servicii-si-tarife/abonamente/apeluri-internationale/index.htm',
                                active: false
                            },
                            {
                                name: 'Roaming',
                                url: 'https://www.vodafone.ro/roaming/',
                                active: false
                            },
                            {
                                name: 'Asigurare mobilă',
                                url: 'https://www.vodafone.ro/personal/magazin-online/utile/asigurare-mobila/',
                                active: false
                            },
                            {
                                name: 'Special pentru copii',
                                url: 'https://www.vodafone.ro/personal/servicii-si-tarife/abonamente/toate-abonamentele/copii/index.htm',
                                active: false
                            },
                            {
                                name: 'Loialitate',
                                url: 'https://www.vodafone.ro/personal/servicii-si-tarife/alege-vodafone/programul-de-loialitate/index.htm#tab-1',
                                active: false
                            }
                        ]
                    },
                    {
                        name: 'Cartelă',
                        url: 'https://www.vodafone.ro/personal/servicii-si-tarife/cartela-vodafone/index.htm',
                        active: false,
                        children: [
                            {
                                name: 'Promoţii',
                                url: 'https://www.vodafone.ro/personal/servicii-si-tarife/cartela-vodafone/oferte-promotionale/index.htm',
                                active: false
                            },
                            {
                                name: 'Mystery Box',
                                url: 'https://www.vodafone.ro/personal/servicii-si-tarife/cartela-vodafone/toata-lumea-castiga/index.htm',
                                active: false
                            },
                            {
                                name: 'Reîncărcare',
                                url: 'https://www.vodafone.ro/personal/servicii-si-tarife/cartela-vodafone/reincarcare-si-valabilitate/index.htm#tab-1',
                                active: false
                            },
                            {
                                name: 'Loialitate',
                                url: 'https://www.vodafone.ro/personal/servicii-si-tarife/cartela-vodafone/program-loialitate/index.htm',
                                active: false
                            },
                            {
                                name: 'Ofertă în avans',
                                url: 'https://www.vodafone.ro/personal/servicii-si-tarife/cartela-vodafone/oferta-in-avans/index.htm',
                                active: false
                            },
                            {
                                name: 'Servicii cartelă',
                                url: 'https://www.vodafone.ro/personal/servicii-si-tarife/cartela-vodafone/servicii-cartela-vodafone/index.htm',
                                active: false
                            },
                            {
                                name: 'Roaming',
                                url: 'https://www.vodafone.ro/roaming/#/?info=cartela',
                                active: false
                            },
                            {
                                name: 'Apeluri Internaționale',
                                url: 'https://www.vodafone.ro/personal/servicii-si-tarife/cartela-vodafone/apeluri-internationale/index.htm',
                                active: false
                            },
                            {
                                name: 'Intrebări frecvente',
                                url: 'https://www.vodafone.ro/personal/asistenta/cartela-vodafone/index.htm',
                                active: false
                            },
                        ]
                    },
                    {
                        name: 'Televiziune și Internet',
                        url: 'https://www.vodafone.ro/servicii-fixe',
                        active: false,
                        children: [                            
                            {
                                name: 'Oferta fix-mobil',
                                url: 'https://impreuna.vodafone.ro/',
                                active: false
                            },
                            {
                                name: 'Pachete',
                                url: 'https://www.vodafone.ro/servicii-fixe/pachete',
                                active: false
                            },
                            {
                                name: 'Oferta router mobil',
                                url: 'https://www.vodafone.ro/routermobil',
                                active: false
                            },
                            {
                                name: '4K',
                                url: 'https://www.vodafone.ro/servicii-fixe/televiziune/4K',
                                active: false
                            },
                            {
                                name: 'Servicii fixe',
                                url: 'https://www.vodafone.ro/servicii-fixe',
                                active: false,
                                children: [
                                    {
                                        name: 'Televiziune',
                                        url: 'https://www.vodafone.ro/servicii-fixe/televiziune',
                                        active: false,
                                    },
                                    {
                                        name: 'Internet',
                                        url: 'https://www.vodafone.ro/servicii-fixe/internet',
                                        active: false,
                                    },
                                    {
                                        name: 'Telefonie',
                                        url: 'https://www.vodafone.ro/servicii-fixe/telefonie',
                                        active: false,
                                    },
                                    {
                                        name: 'Asistență',
                                        url: 'https://www.vodafone.ro/personal/asistenta/tv-si-fix/index.htm',
                                        active: false,
                                    }
                                ]
                            },
                            {
                                name: 'Alte servicii',
                                url: 'https://www.vodafone.ro/personal/vodafonetv/index.htm',
                                active: false,
                                children: [
                                    {
                                        name: 'Vodafone TV',
                                        url: 'https://www.vodafone.ro/personal/vodafonetv/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Internet mobil',
                                        url: 'https://www.vodafone.ro/personal/servicii-si-tarife/internet/internet-pe-mobil/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Internet fix prin WIFI',
                                        url: 'https://www.vodafone.ro/personal/servicii-si-tarife/internet/wi-fi-acasa/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Secure Net',
                                        url: 'https://www.vodafone.ro/personal/servicii-si-tarife/internet/secure-net/index.htm',
                                        active: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        name: 'Business',
                        url: 'https://www.vodafone.ro/business',
                        active: false,
                        children: [
                            {
                                name: 'Oferte pentru antreprenori',
                                url: 'https://www.vodafone.ro/business/oferte-pentru-antreprenori/index.htm',
                                active: false,
                                megaMenu: true,
                                children: [
                                    {
                                        name: 'Pachete convergente',
                                        url: 'https://www.vodafone.ro/business/antreprenori',
                                        active: false,
                                    },
                                    {
                                        name: 'Oferte recomandate',
                                        url: 'https://www.vodafone.ro/business/oferte-pentru-antreprenori/oferte-recomandate/index.htm',
                                        active: false,
                                    },
                                    {
                                        name: 'Magazine Online',
                                        url: 'https://www.vodafone.ro/eshop/',
                                        active: false,
                                        arrow: true,
                                        children: [
                                            {
                                                name: 'Telefoane',
                                                url: 'https://www.vodafone.ro/eshop/toate-telefoanele',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Noutăți',
                                                        url: 'https://www.vodafone.ro/eshop/noutati-telefoane',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'Telefoane Android',
                                                        url: 'https://www.vodafone.ro/eshop/telefoane-android',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'iPhone',
                                                        url: 'https://www.vodafone.ro/eshop/iphone',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'Telefoane Vodafone',
                                                        url: 'https://www.vodafone.ro/eshop/telefoane-vodafone',
                                                        active: false,
                                                    }
                                                ]
                                            },
                                            {
                                                name: 'Accesorii',
                                                url: 'https://www.vodafone.ro/business/magazin-online/accesorii/index.htm',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Huse și carcase',
                                                        url: 'https://www.vodafone.ro/business/magazin-online/accesorii/huse-si-carcase/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Căști',
                                                        url: 'https://www.vodafone.ro/business/magazin-online/accesorii/casti/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Încărcătoare',
                                                        url: 'https://www.vodafone.ro/business/magazin-online/accesorii/incarcatoare/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Baterii externe',
                                                        url: 'https://www.vodafone.ro/business/magazin-online/accesorii/incarcatoare/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Altele',
                                                        url: 'https://www.vodafone.ro/business/magazin-online/accesorii/altele/index.htm',
                                                        active: false
                                                    },
                                                ]
                                            },
                                            {
                                                name: 'Tablete',
                                                url: 'https://www.vodafone.ro/eshop/toate-tabletele',
                                                active: false
                                            },
                                            {
                                                name: 'Modemuri internet',
                                                url: 'https://www.vodafone.ro/eshop/toate-modemurile',
                                                active: false
                                            },
                                            {
                                                name: 'Modemuri internet',
                                                url: 'https://www.vodafone.ro/eshop/toate-modemurile',
                                                active: false
                                            },
                                            {
                                                name: 'Utile',
                                                url: 'https://www.vodafone.ro/business/magazin-online/utile/index.htm',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Detalii comandă',
                                                        url: 'https://www.vodafone.ro/business/magazin-online/utile/detalii-comanda/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Avantaje magazin online',
                                                        url: 'https://www.vodafone.ro/business/magazin-online/utile/avantaje-magazin/index.htm',
                                                        active: false
                                                    }
                                                ]
                                            },
                                            {
                                                name: 'Abonamente',
                                                url: 'https://www.vodafone.ro/business/magazin-online/abonamente/index.htm',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Vodafone Voce Mobilă',
                                                        url: 'https://www.vodafone.ro/business/magazin-online/abonamente/vodafone-voce-mobila/index.htm',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'Vodafone Business Profile',
                                                        url: 'https://www.vodafone.ro/business/magazin-online/abonamente/vodafone-business-profile/index.htm',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'Vodafone Internet Mobil Nelimitat',
                                                        url: 'https://www.vodafone.ro/business/magazin-online/abonamente/vodafone-internet/index.htm',
                                                        active: false,
                                                    }
                                                ]
                                            }

                                        ]
                                    }
                                ]
                            },
                            {
                                name: 'Soluții pentru companii',
                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/index.htm',
                                active: false,
                                megaMenu: true,
                                children: [
                                    {
                                        name: 'Voce și date mobile',
                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-date-mobile/index.htm',
                                        arrow: true,
                                        active: false,
                                        children: [
                                            {
                                                name: 'Voce mobilă',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-date-mobile/voce-mobila/index.htm',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Business Profiles',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-date-mobile/voce-mobila/abonamente-business-profiles/index.htm',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'Convorbiri internaționale',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-date-mobile/voce-mobila/convorbiri-internationale/index.htm',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'Roaming',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-date-mobile/voce-mobila/roaming/index.htm',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'Apelare și mesagerie',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-date-mobile/voce-mobila/apelare-si-mesagerie/index.htm',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'VoLTE',
                                                        url: 'https://www.vodafone.ro/volte',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'eSim',
                                                        url: 'https://www.vodafone.ro/esim',
                                                        active: false,
                                                    }
                                                ]
                                            },
                                            {
                                                name: 'Internet mobil',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-date-mobile/internet-mobil/index.htm',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Internet pe laptop si tabletă',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-date-mobile/internet-mobil/internet-pe-laptop-si-tableta/national-si-roaming/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Roaming',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-date-mobile/voce-mobila/roaming/index.htm',
                                                        active: false
                                                    }
                                                ]
                                            },
                                            {
                                                name: 'Pachete de servicii',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-date-mobile/pachete-de-servicii/index.htm',
                                                active: false
                                            }
                                        ]
                                    },
                                    {
                                        name: 'Voce și internet fix',
                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/index.htm',
                                        arrow: true,
                                        active: false,
                                        children: [
                                            {
                                                name: 'Internet fix',
                                                url: '#',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Internet Fiber Power',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/internet-fix/internet-fiber-power',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'Internet fix cu bandă garantată',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/internet-fix/internet-banda-garantata',
                                                        active: false,
                                                    }
                                                ]
                                            },
                                            {
                                                name: 'Servicii suplimentare internet fix',
                                                url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/internet-fix/servicii-internet-fix/cloud-security',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Cloud Security',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/internet-fix/servicii-internet-fix/cloud-security',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Protecție Anti DDOS',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/internet-fix/servicii-internet-fix/protectie-anti-ddos',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Videoconferintă',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/servicii-suplimentare-internet-fix/videoconferinta/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Data Security',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/internet-fix/servicii-internet-fix/data-security',
                                                        active: false
                                                    }
                                                ]
                                            },
                                            {
                                                name: 'Voce fixă',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/voce-fixa/office-link/index.htm',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Office Link',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/voce-fixa/office-link/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Cloud Voice',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/voce-fixa/cloud-voice/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Business Telefix',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/voce-fixa/business-telefix',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Office Zone',
                                                        url: 'https://www.vodafone.ro/vodafone-business/solutii-pentru-companii/voce-si-internet-fix/voce-fixa/business-telefix/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: '0800 Număr verde',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/0800-numar-verde/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Număr Scurt',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/numar-scurt/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Fax2Email',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/fax2email/index.htm',
                                                        active: false
                                                    },
                                                ]
                                            },
                                            {
                                                name: 'Servicii suplimentare voce fixă',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/servicii-suplimentare-voce-fixa/echipamente-pbx/index.htm',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Echipamente PBX',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/servicii-suplimentare-voce-fixa/echipamente-pbx/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Audioconferintă',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/servicii-suplimentare-voce-fixa/audioconferinta/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Telefonie IP',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/servicii-suplimentare-voce-fixa/telefonie-ip/index.htm',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Contact Center',
                                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/voce-si-internet-fix/servicii-suplimentare-voce-fixa/contact-center/index.htm',
                                                        active: false
                                                    },
                                                ]
                                            },
                                            {
                                                name: 'Date fixe',
                                                url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/date-fixe/ip-vpn',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'IP VPN',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/date-fixe/ip-vpn',
                                                        active: false,
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: 'Televiziune',
                                        url: 'https://www.vodafone.ro/servicii-fixe/business/televiziune/tv-digital-premium-hd',
                                        arrow: true,
                                        active: false,
                                        children: [
                                            {
                                                name: 'Televiziune digitală',
                                                url: '#',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Business TV Digital Optim HD',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/televiziune/tv-digital-optim-hd',
                                                        active: false,
                                                    },
                                                    {
                                                        name: 'Business TV Digital Premium HD',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/televiziune/tv-digital-premium-hd',
                                                        active: false,
                                                    }
                                                ]
                                            },
                                            {
                                                name: 'TV Flexibil (IP TV)',
                                                url: 'https://www.vodafone.ro/servicii-fixe/business/televiziune/tv-flexibil-iptv',
                                                active: false
                                            }
                                        ]
                                    },
                                    {
                                        name: 'Soluții ICT & IoT',
                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/solutii-ict-iot/index.htm',
                                        arrow: true,
                                        active: false,
                                        children: [
                                            {
                                                name: 'Soluții ICT',
                                                url: 'https://www.vodafone.ro/servicii-fixe/business/ict-iot/servicii-ict/data-center-vps',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Servicii data center VPS',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/ict-iot/servicii-ict/data-center-vps',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Cablare Structurată',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/ict-iot/servicii-ict/cablare-structurata',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Business SecureSign',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/ict-iot/servicii-ict/business-securesign',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Printing Solution',
                                                        url: 'https://www.vodafone.ro/servicii-fixe/business/ict-iot/servicii-ict/printing-solution',
                                                        active: false
                                                    },
                                                ]
                                            },
                                            {
                                                name: 'Soluții IoT',
                                                url: 'https://iot.vodafone.ro/companii-mari/',
                                                active: false,
                                                children: [
                                                    {
                                                        name: 'Conectivitate IoT',
                                                        url: 'https://iot.vodafone.ro/solutii/conectivitate-iot/',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Vodafone Tracking Solution',
                                                        url: 'https://iot.vodafone.ro/solutii/vodafone-tracking-solution/',
                                                        active: false
                                                    },
                                                    {
                                                        name: 'Soluții IoT',
                                                        url: 'https://iot.vodafone.ro/solutii/',
                                                        active: false
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        name: 'Securitate',
                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/securitate/index.htm',
                                        arrow: true,
                                        active: false,
                                        children: [
                                            {
                                                name: 'Secure Net',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/securitate/secure-net/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Apple Business Manager',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/securitate/apple-business-manager/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'PC Protection',
                                                url: 'https://www.vodafone.ro/servicii-fixe/business/securitate/pc-protection',
                                                active: false
                                            },
                                            {
                                                name: 'Protecție anti DDoS',
                                                url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/internet-fix/servicii-internet-fix/protectie-anti-ddos ',
                                                active: false
                                            },
                                            {
                                                name: 'Secure Device Manager',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/securitate/secure-device-manager/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Data Security',
                                                url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/internet-fix/servicii-internet-fix/data-security',
                                                active: false
                                            },
                                            {
                                                name: 'Cloud Security',
                                                url: 'https://www.vodafone.ro/servicii-fixe/business/voce-internet-fix/internet-fix/servicii-internet-fix/cloud-security',
                                                active: false
                                            },
                                            {
                                                name: 'Video Surveillance',
                                                url: 'https://www.vodafone.ro/servicii-fixe/business/securitate/video-surveillance',
                                                active: false
                                            }
                                        ]
                                    },
                                    {
                                        name: 'Cloud & Hosting',
                                        url: 'https://www.vodafone.ro/business/solutii-pentru-companii/cloud-and-hosting/index.htm',
                                        arrow: true,
                                        active: false,
                                        children: [
                                            {
                                                name: 'Microsoft Office 365',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/cloud-and-hosting/microsoft-office-365/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Gazduire domeniu si email',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/cloud-and-hosting/gazduire-domeniu-si-email/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Smart Inventory',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/cloud-and-hosting/smart-inventory/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Smart Archive',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/cloud-and-hosting/smart-archive/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Hosting',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/cloud-and-hosting/hosting/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Smart Invoice',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/cloud-and-hosting/smart-invoice/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Smart CRM',
                                                url: 'https://www.vodafone.ro/business/solutii-pentru-companii/cloud-and-hosting/smart-crm/index.htm',
                                                active: false
                                            },
                                        ]
                                    }
                                ]
                            },
                            {
                                name: 'My Vodafone',
                                url: 'https://www.vodafone.ro/myvodafone/index.htm',
                                active: false,
                                children: [
                                    {
                                        name: 'My Vodafone',
                                        url: 'https://www.vodafone.ro/myvodafone/index.htm',
                                        active: false,
                                    },
                                    {
                                        name: 'My Vodafone Fix & TV',
                                        url: 'https://my.upc.ro',
                                        active: false,
                                    }
                                ]
                            },
                            {
                                name: 'De ce Vodafone',
                                url: 'https://www.vodafone.ro/business/de-ce-vodafone/alege-vodafone/index.htm',
                                active: false,
                                children: [
                                    {
                                        name: 'Alege Vodafone',
                                        url: 'https://www.vodafone.ro/business/de-ce-vodafone/alege-vodafone/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Portabilitate',
                                        url: 'https://www.vodafone.ro/business/de-ce-vodafone/alege-vodafone/portabilitate/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Programul de loialitate',
                                        url: 'https://www.vodafone.ro/business/de-ce-vodafone/alege-vodafone/programul-de-loialitate/index.htm#tab-1',
                                        active: false
                                    },
                                    {
                                        name: 'Mobile advertising',
                                        url: 'https://www.vodafone.ro/business/de-ce-vodafone/alege-vodafone/mobile-advertising/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Testimoniale',
                                        url: 'https://www.vodafone.ro/business/de-ce-vodafone/alege-vodafone/testimoniale/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Studii de caz',
                                        url: 'https://www.vodafone.ro/business/de-ce-vodafone/alege-vodafone/studii-de-caz/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Parteneri autorizați',
                                        url: 'https://www.vodafone.ro/business/de-ce-vodafone/alege-vodafone/parteneri-autorizati/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Harta de acoperire',
                                        url: 'https://www.vodafone.ro/business/de-ce-vodafone/alege-vodafone/harta-de-acoperire/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Cere o ofertă',
                                        url: 'https://www.vodafone.ro/business/contact/cerere-oferta/index.htm',
                                        active: false
                                    },
                                    {
                                        name: 'Consultant dedicat',
                                        url: 'https://www.vodafone.ro/business/de-ce-vodafone/alege-vodafone/consultant-dedicat/index.htm',
                                        active: false
                                    }
                                ]
                            },
                            {
                                name: 'Asistență',
                                url: 'https://www.vodafone.ro/business/asistenta/',
                                active: false,
                                megaMenu: true,
                                children: [
                                    {
                                        name: 'Factură și plată',
                                        url: 'https://www.vodafone.ro/business/asistenta/factura-si-plata/index.htm',
                                        active: false,
                                        arrow: true,
                                        children: [
                                            {
                                                name: 'Plata facturii',
                                                url: 'https://www.vodafone.ro/business/asistenta/factura-si-plata/plata-facturii/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Factură explicată',
                                                url: 'https://www.vodafone.ro/business/asistenta/factura-si-plata/factura-explicata/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Ultima factură emisă',
                                                url: 'https://www.vodafone.ro/business/asistenta/factura-si-plata/ultima-factura-emisa/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'CD Online cu factura',
                                                url: 'https://www.vodafone.ro/business/asistenta/factura-si-plata/cd-online-cu-factura/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Curs valutar',
                                                url: 'https://www.vodafone.ro/curs-valutar/',
                                                active: false
                                            },
                                            {
                                                name: 'Factură fiscală online',
                                                url: 'https://www.vodafone.ro/business/asistenta/factura-si-plata/factura-fiscala-online/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Direct debit',
                                                url: 'https://www.vodafone.ro/business/asistenta/factura-si-plata/direct-debit/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Garanții',
                                                url: 'https://www.vodafone.ro/business/asistenta/factura-si-plata/garantii/index.htm',
                                                active: false
                                            },
                                        ]
                                    },
                                    {
                                        name: 'Abonamente și extraopțiuni',
                                        url: 'https://www.vodafone.ro/business/asistenta/factura-si-plata/index.htm',
                                        active: false,
                                        arrow: true,
                                        children: [
                                            {
                                                name: 'Abonamente telefonie mobilă',
                                                url: 'https://www.vodafone.ro/business/asistenta/abonamente-si-extraoptiuni/abonamente-telefonie-mobila/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Extraopțiuni telefonie mobilă',
                                                url: 'https://www.vodafone.ro/business/asistenta/abonamente-si-extraoptiuni/extraoptiuni-telefonie-mobila/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Servicii TV',
                                                url: 'https://www.vodafone.ro/business/asistenta/abonamente-si-extraoptiuni/servicii-tv/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Promoții abonamente',
                                                url: 'https://www.vodafone.ro/business/asistenta/abonamente-si-extraoptiuni/promotii-abonamente/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Abonamente telefonie fixă',
                                                url: 'https://www.vodafone.ro/business/asistenta/abonamente-si-extraoptiuni/abonamente-telefonie-fixa/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Extraopțiuni telefonie fixă',
                                                url: 'https://www.vodafone.ro/business/asistenta/abonamente-si-extraoptiuni/extraoptiuni-telefonie-fixa/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Servicii Internet Fix',
                                                url: 'https://www.vodafone.ro/business/asistenta/abonamente-si-extraoptiuni/servicii-internet-fix/index.htm',
                                                active: false
                                            },
                                        ]
                                    },
                                    {
                                        name: 'Informații utile',
                                        url: 'https://www.vodafone.ro/business/asistenta/informatii-utile/index.htm',
                                        active: false,
                                        arrow: true,
                                        children: [
                                            {
                                                name: 'Administrator de cont',
                                                url: 'https://www.vodafone.ro/business/asistenta/informatii-utile/administrator-de-cont/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Programul de loalitate',
                                                url: 'https://www.vodafone.ro/business/asistenta/informatii-utile/programul-de-loialitate/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Formulare și documente utile',
                                                url: 'https://www.vodafone.ro/business/asistenta/informatii-utile/formulare-si-documente-utile/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Magazinul online',
                                                url: 'https://www.vodafone.ro/business/asistenta/informatii-utile/magazinul-online/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Magazine și distribuitori',
                                                url: 'https://www.vodafone.ro/business/asistenta/informatii-utile/magazine-si-distribuitori/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Utilizator al contului',
                                                url: 'https://www.vodafone.ro/business/asistenta/informatii-utile/utilizator-al-contului/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Portabilitate',
                                                url: 'https://www.vodafone.ro/business/asistenta/informatii-utile/portabilitate/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Dicționar termeni tehnici',
                                                url: 'https://www.vodafone.ro/business/asistenta/informatii-utile/dictionar-termeni-tehnici/index.htm',
                                                active: false
                                            },
                                            {
                                                name: 'Contract',
                                                url: 'https://www.vodafone.ro/business/asistenta/informatii-utile/contract/index.htm',
                                                active: false
                                            },
                                        ]
                                    },
                                    {
                                        name: 'Contactează-ne',
                                        url: 'https://www.vodafone.ro/business/asistenta/contact/index.htm',
                                        active: false,
                                        arrow: true,
                                        children: [
                                            {
                                                name: 'Sună-ne',
                                                url: 'https://www.vodafone.ro/business/asistenta/contact/suna-ne/index.htm',
                                                active: false,
                                            },
                                            {
                                                name: 'Magazine Vodafone',
                                                url: 'https://www.vodafone.ro/magazine-vodafone/index.htm',
                                                active: false,
                                            }
                                        ]
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        name: 'Asistență',
                        url: 'https://www.vodafone.ro/personal/asistenta/abonamente/index.htm',
                        active: false,
                        children: [
                            {
                                name: 'Abonament',
                                url: 'https://www.vodafone.ro/personal/asistenta/abonamente/index.htm',
                                active: false
                            },
                            {
                                name: 'Cartelă',
                                url: 'https://www.vodafone.ro/personal/asistenta/cartela-vodafone/index.htm',
                                active: false
                            },
                            {
                                name: 'Servicii fixe și TV',
                                url: 'https://www.vodafone.ro/personal/asistenta/tv-si-fix/index.htm',
                                active: false
                            },
                            {
                                name: 'Roaming și Internaţional',
                                url: 'https://www.vodafone.ro/personal/asistenta/roaming-si-international/index.htm',
                                active: false
                            },
                            {
                                name: 'My Vodafone',
                                url: 'https://www.vodafone.ro/personal/asistenta/myvodafone/index.htm',
                                active: false,
                                children: [
                                    {
                                        name: 'My Vodafone',
                                        url: 'https://www.vodafone.ro/myvodafone/index.htm',
                                        active: false,
                                    },
                                    {
                                        name: 'My Vodafone Fix & TV',
                                        url: 'https://my.upc.ro',
                                        active: false,
                                    }
                                ]
                            },
                            {
                                name: 'Factura ta',
                                url: 'https://factura.vodafone.ro/',
                                active: false
                            },
                            {
                                name: 'Aplicaţii și Servicii',
                                url: 'https://www.vodafone.ro/personal/asistenta/aplicatii-si-servicii/index.htm',
                                active: false
                            },
                            {
                                name: 'Comenzi online',
                                url: 'https://www.vodafone.ro/personal/asistenta/comenzi-online/index.htm',
                                active: false
                            },
                            {
                                name: 'Contactează-ne',
                                url: 'https://www.vodafone.ro/personal/asistenta/Contacteaza-ne/index.htm',
                                active: false
                            },
                        ]
                    },
                    {
                        name: 'Zoom',
                        url: 'https://zoom.vodafone.ro/',
                        active: false,
                        children: [
                            {
                                name: 'Reviews',
                                url: 'https://zoom.vodafone.ro/category/video/reviews/',
                                active: false
                            },
                            {
                                name: 'Devices',
                                url: 'https://zoom.vodafone.ro/category/devices/',
                                active: false
                            },
                            {
                                name: 'Trending',
                                url: 'https://zoom.vodafone.ro/category/trending/',
                                active: false
                            }
                        ]
                    }
                ]
            }
        },
        methods: {
            enter(item) {
                if (this.windowWidth > 1201) {
                    item.active = true;
                }
            },
            leave(item) {
                if (this.windowWidth > 1201) {
                    item.active = false;
                }
            },
            toggleSubmenu(event ,item) {
                if (this.windowWidth < 1200) {
                    if (!item.children) {
                        window.location.href = item.url;
                    }
                    const items = this.items;
                    if ( !item.active) {
                        item.active = true;
                    } else {
                        item.active = false
                    }
                } else {
                    window.location.href = item.url;
                }
            },
            getWindowWidth(event) {
                this.windowWidth = document.documentElement.clientWidth;
            }
        },
        mounted() {
            this.$nextTick(function() {
                window.addEventListener('resize', this.getWindowWidth);
                this.getWindowWidth()
            })
        },
    };
</script>

<style lang="scss" scoped>
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/variables";
    @import "~bootstrap/scss/mixins";
    @import "~bootstrap/scss/utilities";
    @import "~bootstrap/scss/grid";
    @import "~bootstrap/scss/reboot";

    header {
        position: relative;
        width: 100%;
        background-color: rgb(255, 255, 255);
        z-index: 10;
        border-bottom: 1px solid rgb(175, 175, 175);
        .container {
            max-width: 1200px;
            margin: 0 auto;
            @include media-breakpoint-down(md) {
                padding-left: 8px;
                padding-right: 8px;
            }
        }
        .vodafone-logo {
            display: flex;
            margin: 12px 10px 12px 0px;
            @include media-breakpoint-down(md) {
                margin: 8px 10px 8px 0px;
            }
            svg {
                @include media-breakpoint-down(sm) {
                    width: 32px;
                    height: 32px;
                }
            }
            img {
                width: 48px;
                height: 48px;
                max-width: inherit;
                @include media-breakpoint-down(sm) {
                    width: 32px;
                    height: 32px;
                }
            }
        }
        nav {
            font-family: Vodafone Lt;
            width: 100%;
            ul {
                list-style: none;
                padding: 0px;
                border-width: 0px;
                border-style: initial;
                border-color: initial;
                border-image: initial;
                margin: 0px;
                float: left;
                &.max300 {
                    @include media-breakpoint-up(lg) {
                        max-width: 300px;
                    }
                }
                &.primary-nav {
                    transition: all .1s ease;
                    @include media-breakpoint-down(lg) {
                        left: 100%;
                        position: fixed;
                        width: auto;
                        right: 0px;
                        display: block;
                        top: 72px;
                        bottom: 0px;
                        background-color: rgba(255, 255, 255, 0.95);
                        margin-top: 1px;
                        z-index: 10;
                        overflow-y: scroll;
                        overflow-x: hidden;
                    }
                    @include media-breakpoint-down(md) {
                        top: 64px;
                    }
                    @include media-breakpoint-down(sm) {
                        top: 48px;
                    }
                    &.mobile_toggle {
                        left: 45px;
                    }
                }
                li {
                    float: left;
                    display: block;
                    @include media-breakpoint-down(lg) {
                        width: 100%;
                    }
                    &.mega-menu-item {
                        @include media-breakpoint-up(lg) {
                            border-right: 2px solid rgb(244, 244, 244);
                                float: inherit !important;
                        }
                        a {
                            position: relative;
                        }
                    }
                    a {
                        display: block;
                        color: rgb(74, 77, 78);
                        font-size: 24px;
                        line-height: 30px;
                        text-decoration: none;
                        border-width: 0px;
                        border-style: initial;
                        border-color: initial;
                        border-image: initial;
                        padding: 20px;
                        cursor: pointer;
                        &:hover {
                            text-decoration: none;
                            color: #e60000;
                        }
                        &.main-links {
                            &.active {
                                @include media-breakpoint-up(lg) {
                                    border-bottom: 2px solid #e60000;
                                }
                            }
                        }
                        &.active {
                            color: #e60000 !important;
                            @include media-breakpoint-up(lg) {
                                background-color: #ffffff;
                            }
                        }
                    }
                    .level {
                        background-color: rgba(255, 255, 255, 0.95);
                        position: absolute;
                        left: 0px;
                        top: 100%;
                        width: auto;
                        &--primary {
                            @include media-breakpoint-down(lg) {
                                background-color: unset;
                                position: relative;
                                padding-left: 20px;
                            }
                        }
                        &--mega-menu {
                            width: 100%;
                            @include media-breakpoint-up(lg) {
                                background-color: #ffffff;
                            }
                        }
                        &--mega-menu-right {
                            @include media-breakpoint-up(lg) {
                                width: calc(100% - 300px);
                                position: absolute;
                                left: 300px;
                                right: 0px;
                                top: 0px;
                                display: block;
                                min-height: 100%;
                                background-color: #ffffff;
                            }
                        }
                        &--mega-menu-right-list {
                            @include media-breakpoint-up(lg) {
                                display: flex;
                                flex-wrap: wrap;
                                align-items: flex-start;
                            }
                            
                        }
                        &--mega-menu-right-list-item {
                            @include media-breakpoint-up(lg) {
                                width: 50% !important;
                            }
                        }
                        &--mega-menu-right-list-item > a {
                            @include media-breakpoint-up(lg) {
                                font-weight: bold;
                                font-size: 16px !important;
                                margin: 10px 0 0;
                                text-transform: uppercase;
                            }
                        }
                        &--mega-menu-right-list-item a {
                            @include media-breakpoint-up(lg) {
                                font-size: 16px !important;
                                padding: 5px 15px !important
                            }
                        }

                        
                        
                        ul {
                            width: 100%;
                            padding-left: 40px;
                            list-style: none;
                            padding: 0px;
                            border-width: 0px;
                            border-style: initial;
                            border-color: initial;
                            border-image: initial;
                            margin: 0px;
                            @include media-breakpoint-up(lg) {
                                white-space: nowrap;
                            }
                            &.sub-nav {
                                @include media-breakpoint-up(lg) {
                                    padding-left: 55px;
                                }
                            }
                            li {
                                float: left;
                                position: relative;
                                &.position-unset {
                                    position: inherit !important;
                                }
                                a {
                                    font-size: 20px;
                                    padding: 10px 15px;
                                    display: block;
                                    line-height: 1;
                                    &:hover {
                                        @include media-breakpoint-up(lg) {
                                            background-color: #ffffff;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .arrow-r {
                @include media-breakpoint-up(lg) {
                    position: absolute;
                    display: inline-block;
                    width: 1.5rem;
                    height: 1.5rem;
                    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA2My4xICgxMDEwMTApIC0gaHR0cHM6Ly9za2V0Y2guY29tIC0tPgogICAgPHRpdGxlPjQxQTA0OThCLUZDOEUtNDk5Mi04M0RBLUM5RjA1RTdCMkExMjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggc2tldGNodG9vbC48L2Rlc2M+CiAgICA8ZyBpZD0iTUVOVSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ik1FTklVLUVCVSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ1OS4wMDAwMDAsIC0xNDguMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJCcmVhZGNydW1iIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNzEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcxLjAwMDAwMCwgNDcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikljb24tU2V0cy0vLVN5c3RlbS0vLWNoZXZyb25fZG93bi0vLSMzMzMzMzMtQ29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzAwLjAwMDAwMCwgNDIuMDAwMDAwKSByb3RhdGUoLTkwLjAwMDAwMCkgdHJhbnNsYXRlKC0zMDAuMDAwMDAwLCAtNDIuMDAwMDAwKSB0cmFuc2xhdGUoMjg4LjAwMDAwMCwgMzAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJjaGV2cm9uX2Rvd24iPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9ImJnIiBmaWxsLW9wYWNpdHk9IjAiIGZpbGw9IiNEOEQ4RDgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjAwMDAwMCwgMTIuMDAwMDAwKSByb3RhdGUoOTAuMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjAwMDAwMCwgLTEyLjAwMDAwMCkgIiBwb2ludHM9IjAgMCAyNCAwIDI0IDI0IDAgMjQiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iU2hhcGUiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBwb2ludHM9IjIwLjUgOC41IDEyIDE3IDMuNSA4LjUiPjwvcG9seWxpbmU+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==) 0% 0% / 1.5rem 1.5rem;
                    right: 15px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .myvodafone {
                float: right;
                position: relative;
                display: flex;
                align-items: center;
                height: 100%;
                cursor: pointer;
                &--list {
                    position: absolute;
                }
                a {
                    padding: 20px;
                    display: flex;
                    align-items: center;
                    @include media-breakpoint-down(md) {
                        padding: 10px;
                    }
                    @media (min-width: 992px) and (max-width: 1040px) {
                        padding: 20px 0;
                    }
                    &.active {
                        border-bottom: none;
                    }
                }
                img {
                    width: 32px;
                    height: 32px;
                }
                .level {
                    width: 195px;
                    @media (max-width: 1440px) {
                        left: unset;
                        right: 0;
                    }
                    ul {
                        padding: 0;
                    }
                }
                .user-icon {
                    display: inline-block;
                    width: 32px;
                    height: 32px;
                    background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iNWQ2YmU1Y2YtOWJhMy00ZGUzLTk0MmMtNzEwZjIxOTMwYjQ1IiBkYXRhLW5hbWU9IklDT04iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjE5MiIgaGVpZ2h0PSIxOTIiIHZpZXdCb3g9IjAgMCAxOTIgMTkyIj48dGl0bGU+YWRtaW48L3RpdGxlPjxwYXRoIGlkPSJhODEyNjNmYS1mOTY2LTQxMDUtYWVjNi1jNzJhYTViYjM5MGUiIGRhdGEtbmFtZT0iJmx0O1BmYWQmZ3Q7IiBkPSJNMTU2LDE2NC4xYy02LjQ4LTQzLjg4LTMzLjE3LTY0LjIzLTU5LjY0LTY0LjIzUzQyLjQ5LDEyMC4yMSwzNiwxNjQuMDkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjgiLz48cmVjdCB3aWR0aD0iMTkyIiBoZWlnaHQ9IjE5MiIgZmlsbD0ibm9uZSIvPjxjaXJjbGUgaWQ9ImYzZjhhYWJmLWUyOGQtNDQ3MS05MDI3LWNjMGY2ZDViMmQyZCIgZGF0YS1uYW1lPSImbHQ7UGZhZCZndDsiIGN4PSI5NiIgY3k9IjYzLjg3IiByPSIzNiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iOCIvPjwvc3ZnPg==) 0% 0% / 2rem 2rem;
                    @include media-breakpoint-down(md) {
                        background-size: 1.25rem;
                        background-repeat: no-repeat;
                        width: 1.25rem;
                        height: 1.25rem;
                    }
                }
            }
            .mobile-burger {
                float: right;
                padding: 10px;
                align-items: center;
                height: 100%;
                display: none;
                @include media-breakpoint-down(lg) {
                    display: flex;
                }
                &--icon {
                    display: inline-block;
                    width: 1.25rem;
                    height: 1.25rem;
                    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5pY19tZW51PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IjAxLUF0b21zLS8tSWNvbnMtLy1TeXN0ZW0tLy1tZW51LS8tIzMzMzMzMyI+CiAgICAgICAgICAgIDxnIGlkPSJtZW51Ij4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJiZyIgZmlsbC1vcGFjaXR5PSIwIiBmaWxsPSIjRDhEOEQ4IiBwb2ludHM9IjAgMCAyNCAwIDI0IDI0IDAgMjQiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMS41LDE4LjUgTDIuNSwxOC41IiBpZD0icGF0aF8xIiBzdHJva2U9IiMzMzMzMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTIxLjUsMTIgTDIuNSwxMiIgaWQ9InBhdGhfMSIgc3Ryb2tlPSIjMzMzMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yMS41LDUuNSBMMi41LDUuNSIgaWQ9InBhdGhfMSIgc3Ryb2tlPSIjMzMzMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+) 0% 0% / 1.25rem 1.25rem;
                }
                &--icon-show {
                    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5pY19jbG9zZV9yZWQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iMDEtQXRvbXMtLy1JY29ucy0vLVN5c3RlbS0vLWNsb3NlLS8tI0U2MDAwMCI+CiAgICAgICAgICAgIDxnIGlkPSJjbG9zZSI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iYmciIGZpbGwtb3BhY2l0eT0iMCIgZmlsbD0iI0Q4RDhEOCIgcG9pbnRzPSIwIDAgMjQgMCAyNCAyNCAwIDI0Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjAsNCBMNCwyMCIgaWQ9IlNoYXBlIiBzdHJva2U9IiNFNjAwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTQsNCBMMjAsMjAiIGlkPSJTaGFwZSIgc3Ryb2tlPSIjRTYwMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+) 0% 0% / 1.25rem 1.25rem;
                }
            }
        }
        .w-100 {
            width: 100% !important;
        }
        .flex-nowrap {
            flex-wrap: nowrap !important;
        }
        .d-flex {
            display: flex !important;
        }
    }
</style>
